@if (projectForm) {
  <form [formGroup]="projectForm">
    <nb-card>
      <nb-card-header >
        <div class="back-and-title">
          <a
            nbButton
            ghost
            status="primary"
            (click)="close()"
          >
            <i class="fas fa-circle-chevron-left fa-xl"></i>
          </a>
          <div class="title" [innerHTML]="title | translate"></div>
        </div>
      </nb-card-header>
      <!-- FORM -->
      <nb-card-body>

        <nb-tabset fullWidth>
          <nb-tab tabTitle="{{ 'Desired gains' | translate }}">
            <div class="mx-3 mt-4 mb-3">
              {{ "Take into account for the bouquet of works" | translate }}:
              <nb-radio-group
                name="global_gain"
                formControlName="global_gain"
              >
                <nb-radio [value]="true">
                  {{ "The global gain shown below" | translate }}
                </nb-radio>
                <nb-radio [value]="false">
                  {{ "The sum of the gains from each action that makes up the bouquet of works" | translate }}
                </nb-radio>
              </nb-radio-group>
            </div>
            <div formArrayName="gains">
              <!-- GAIN FORMS -->
              <nb-accordion multiple class="mt-2">
                @for (gain of gains.controls; track gain; let first = $first; let i = $index) {
                  <nb-accordion-item expanded="true" disabled="true">
                    <nb-accordion-item-header>
                      <span>
                        {{ "Gain #" | translate }}{{ i + 1}}
                      </span>
                      <a
                        nbButton
                        ghost
                        status="primary"
                        (click)="removeGain(i)"
                        class="accordion-button"
                      >
                        <i class="fal fa-trash-can fa-xl"></i>
                      </a>
                    </nb-accordion-item-header>
                    <nb-accordion-item-body>
                      <ng-container *ngTemplateOutlet="fields; context: { i, gain }"></ng-container>
                    </nb-accordion-item-body>
                  </nb-accordion-item>
                }
                <!-- ADD A NEW GAIN -->
                <nb-accordion-item expanded="false" disabled="true" (click)="addGain()" class="accordion-item-as-button">
                  <nb-accordion-item-header>
                    <span>
                      (+)
                      {{ "Add another gain" | translate }}
                    </span>
                  </nb-accordion-item-header>
                </nb-accordion-item>
              </nb-accordion>
            </div>
          </nb-tab>
          <nb-tab tabTitle="{{ 'Real gains' | translate }}" disabled>
          </nb-tab>
        </nb-tabset>
      </nb-card-body>
    </nb-card>

    <!-- FIELDS TEMPLATE -->
    <ng-template #fields let-i="i" let-gain="gain">
      <div class="form-group" [formGroup]="gain">

        <!-- KWH GAIN -->
        <div class="form-field">
          <label for="theoretical_savings_full_year">{{ "Gain #{nb} in kWh/year" | translate: {nb: i + 1} }}</label>
          <input
            nbInput
            id="theoretical_savings_full_year"
            type="number"
            formControlName="theoretical_savings_full_year"
            fullWidth
            integerOnly
          >
        </div>

        <!-- ENERGY TYPE -->
        <div class="form-field" [nbSpinner]="(energyTypes$ | async)?.loading">
          <label for="energy_type">{{ 'Related energy' | translate }}</label>
          <nb-select
            id="energy_type"
            formControlName="energy_type"
            fullWidth
          >
            @for (energyType of (energyTypes$ | async)?.data; track energyType.id) {
              <nb-option [value]="energyType.id">
                {{ energyType.name }}
              </nb-option>
            }
          </nb-select>
        </div>
      </div>
    </ng-template>
  </form>
}
